(function ($) {
  Drupal.behaviors.onlineServicesFormatterV1 = {
    attach: function (context, settings) {
    // var $templates = $('.online-services', context);
    // $('.online-services__content__item', $templates).each(function(index) {
    //  if (index == 1) {
    //    $(this).addClass('first');
    //  }
    //  if (! (index % 2)) {
    //    $(this).addClass('odd');
    //  }
    //  else {
    //    $(this).addClass('even');
    //  }
    //  // index++;	
    // });

    // $('.online-services__content__item').last().addClass('last');
    }
  };
})(jQuery);
